import axios from 'axios';
import cookie from 'js-cookie';

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use((config) => {
  const tokenState = cookie.get('token');
  if (tokenState) {
    try {
      const parsed = JSON.parse(tokenState);
      if (parsed.value) {
        config.headers.Authorization = parsed.value;
      }
    } catch (e) {
      // Cookie may not be valid JSON
    }
  }

  const sessionState = sessionStorage.getItem('sessionId');
  if (sessionState) {
    try {
      const parsed = JSON.parse(sessionState);
      if (parsed.value) {
        config.headers.sessionId = parsed.value;
      }
    } catch (e) {
      // sessionStorage may not be valid JSON
    }
  }

  return config;
});

export default apiClient;
